"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCalendarAddOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M5 4H4c-1.333 0-2 .668-2 2.004V20c0 1.333.667 2 2 2h8.126A4.01 4.01 0 0112 21v-1H4V10h8.126a4 4 0 011.228-2H4V6h12v1c.729 0 1.412.195 2 .535V6c0-1.333-.667-2-2-2h-1V2.941C15 2.314 14.667 2 14 2s-1 .314-1 .941V4H7.004V3c0-.667-.334-1-1.004-1-.67 0-1.002.333-1 1v1z' }),
    react_1.default.createElement("path", { d: 'M8.94 12.57C8.817 12.19 8.504 12 8 12h-.998C6.335 11.999 6 12.332 6 13c0 .668.333 1.001 1 1h.535a4.02 4.02 0 011.405-1.43zM7 16c-.666 0-1 .333-1 1 0 .668.333 1.001 1 1h.535A3.981 3.981 0 017 16zM15 11a1 1 0 112 0v4h4a1 1 0 110 2h-4v4a1 1 0 11-2 0v-4h-4a1 1 0 110-2h4v-4z' }))); };
exports.default = SvgCalendarAddOutline;
//# sourceMappingURL=CalendarAddOutline.js.map